import { html } from 'lit';

import { events, messageBus } from '@schibsted-nmp/advertising-events';
import { AdServer, PlacementId } from '@schibsted-nmp/advertising-shared';

import { AdVendor } from './AdVendor';
import { renderGamAd } from '../components/googleAdManager/renderAd';

export class GamAdVendor extends AdVendor {
  placementId: PlacementId;

  constructor(placementId: PlacementId) {
    super();
    this.adServer = AdServer.GAM;
    this.placementId = placementId;
    this.containerId = `${placementId}--container`;
  }

  cleanupEvents(): void {}

  updated(): void {}

  setupEvents({ handleAdTypeChange, handleStatusChange }): void {
    const eventCallback = (event) => {
      const payload = events.PODLET.AD_CONTAINER_STATUS.getPayload(event);
      if (payload.containerId === this.containerId) {
        // Apply styles and classes to the host element
        handleAdTypeChange(payload.adType);
        handleStatusChange(payload.status);
      }
    };
    const peekEvent = messageBus.peek(
      events.PODLET.channel,
      events.PODLET.AD_CONTAINER_STATUS.topic
    );
    if (peekEvent) {
      eventCallback(peekEvent);
    }
    this.cleanupEvents = messageBus.subscribe(
      events.PODLET.channel,
      events.PODLET.AD_CONTAINER_STATUS.topic,
      eventCallback
    );
  }

  requestAd(): void {
    renderGamAd({
      placementId: this.placementId,
      containerId: this.containerId || `${this.placementId}--container`
    });
  }

  render() {
    return html`
      <slot
        name="${`${this.placementId}--slot`}"
        id="${this.placementId}"
      ></slot>
    `;
  }
}
